export const PrescribedMatters = `EmploymentEquity/PrescribedMatters`;